import { NextRouter } from 'next/router';

export const getUtmTagsFromQuery = ({ query }: Pick<NextRouter, 'query'>) => {
  return {
    utm_source: query.utm_source,
    utm_medium: query.utm_medium,
    utm_campaign: query.utm_campaign,
    utm_term: query.utm_term,
    utm_content: query.utm_content,
  };
};
